import { Component, OnInit, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Builder } from 'path-shared/models/builder';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { NotificationService } from 'path-shared/services/notification/notification.service';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { PermissionDialogComponent } from 'path-shared/components/permission-dialog/permission-dialog.component';
import { MotiusNoNotificacioFilter } from '../../models/motius-notificacio-filter';
import { MotiusNoNotificacioFilterComponent } from '../../components/motius-notificacio-filter/motius-notificacio-filter.component';
import { MotiusNoNotificacioEditorComponent } from '../../components/motius-notificacio-editor/motius-notificacio-editor.component';
import { MotiusNoNotificacioTableComponent } from '../../components/motius-notificacio-table/motius-notificacio-table.component';


@Component({
  selector: 'app-motius-notificacio',
  templateUrl: './motius-notificacio.component.html',
  styleUrls: ['./motius-notificacio.component.scss']
})
export class MotiusNoNotificacioComponent implements OnInit, AfterViewInit {

  permissionDialogRef: MatDialogRef<PermissionDialogComponent>;
  activeFilters: string[] = [];
  filterData: MotiusNoNotificacioFilter;
  somIdFoo: number;
  dataDialog: ComponentDialog = Builder.newComponentDialog();

  @ViewChild(MotiusNoNotificacioTableComponent) motiusNoNotificacioTable: MotiusNoNotificacioTableComponent;

  constructor(
    private dialog: MatDialog,
    public auth: AuthorizationService,
    private i18n: I18n,
    private not: NotificationService,
    public thisDialogRef: MatDialogRef<MotiusNoNotificacioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.filterData = new MotiusNoNotificacioFilter('somId', 'desc');
      if (data !== undefined) {
        this.dataDialog = data;
      }
    }

  ngOnInit(): void {
    this.auth.UserCanSeePage(this.auth.Pages.MotiusNoNotificacio);
    this.motiusNoNotificacioTable.itemClicked.subscribe(secure_id => {
      this.update(secure_id);
    });
    this.motiusNoNotificacioTable.itemSelected.subscribe(codi => {
      this.thisDialogRef.close(codi);
    });
  }

  ngAfterViewInit() {
    if (!this.dataDialog.isDialog) {
      this.not.titleChange(this.i18n('Motivos no notificación'));
    }
  }

  edit() {
    const idSeleccionat: string = this.motiusNoNotificacioTable.displayedItems['checkedItems'][0];
    this.update(idSeleccionat);
  }

  create() {
    this.update(null);
  }

  update(secure_id: string) {
    const data: ComponentDialog = Builder.newComponentDialog(true, false, secure_id);

    const ref = this.dialog.open(MotiusNoNotificacioEditorComponent, {
      width: '60%',
      closeOnNavigation: false,
      autoFocus: true,
      data: data
    });

    ref.afterClosed().subscribe(updated => {
      if (updated) { this.motiusNoNotificacioTable.load(); }
    });
  }

  refresh() {
    this.motiusNoNotificacioTable.load();
  }

  onFilterClicked() {
    const ref = this.dialog.open(MotiusNoNotificacioFilterComponent, {
      width: '50%',
      closeOnNavigation: false,
      autoFocus: true,
      data: {
        'filter': this.motiusNoNotificacioTable.filter
      }
    });

    ref.componentInstance.notify.subscribe((filter: MotiusNoNotificacioFilter) => {
      this.motiusNoNotificacioTable.filter.set(filter);
      this.motiusNoNotificacioTable.load();
    });
  }

  onRowSelected(somid) {
    this.update(somid);
  }

  generateExcel() {
    this.motiusNoNotificacioTable.generateExcel();
  }

}
